function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { makeAutoObservable } from 'mobx';
import clientCredentialApi from '../api/clientCredentialAPI';
import { Claim } from '../models/Claim';
import { ClientCredential } from '../models/ClientCredential';
import { isEmpty } from 'lodash';
export var ClientCredentialStore = /*#__PURE__*/ function() {
    "use strict";
    function ClientCredentialStore() {
        var _this = this;
        _class_call_check(this, ClientCredentialStore);
        _define_property(this, "isLoading", true);
        _define_property(this, "searchTerm", '');
        _define_property(this, "clientCredentials", []);
        _define_property(this, "clientCredential", new ClientCredential());
        _define_property(this, "claims", []);
        _define_property(this, "claim", new Claim());
        _define_property(this, "fetchAllClientCredentials", function() {
            return _async_to_generator(function() {
                var clientCredentials, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                clientCredentialApi.clientCredential.getAll()
                            ];
                        case 1:
                            clientCredentials = _state.sent();
                            this.setClientCredentials(clientCredentials.data.items);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "getClientCredentialById", function(credentialId, builders) {
            return _async_to_generator(function() {
                var _tmp, cred;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = this.clientCredentials.length < 1;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.fetchAllClientCredentials()
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            _tmp;
                            cred = this.clientCredentials.find(function(x) {
                                return x.id === credentialId;
                            });
                            if ((cred === null || cred === void 0 ? void 0 : cred.builderId) && !isEmpty(builders)) {
                                cred.builder = builders.find(function(builder) {
                                    return builder.id === cred.builderId;
                                });
                            }
                            cred && this.setClientCredential(cred);
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "fetchAllClaims", function() {
            return _async_to_generator(function() {
                var claims, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                clientCredentialApi.claims.getAll()
                            ];
                        case 1:
                            claims = _state.sent();
                            if (claims.data) {
                                this.setClaims(claims.data.items);
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        makeAutoObservable(this);
    }
    _create_class(ClientCredentialStore, [
        {
            key: "setClientCredentials",
            value: function setClientCredentials(value) {
                this.clientCredentials = value;
            }
        },
        {
            key: "setIsLoading",
            value: function setIsLoading(value) {
                this.isLoading = value;
            }
        },
        {
            key: "setSearchTerm",
            value: function setSearchTerm(value) {
                this.searchTerm = value;
            }
        },
        {
            key: "setClientCredential",
            value: function setClientCredential(value) {
                this.clientCredential = value;
            }
        },
        {
            key: "setClaims",
            value: function setClaims(value) {
                this.claims = value;
            }
        },
        {
            key: "setClaim",
            value: function setClaim(value) {
                this.claim = value;
            }
        }
    ]);
    return ClientCredentialStore;
}();
